<script>
import Icon from "@/components/atoms/icon";
import Titre from "@/components/atoms/titre";
import Divider from "@/components/atoms/divider";
import LazyImage from "@/components/atoms/lazy-image";

export default {
  name: "WidgetPlanningTabTraiteurFetes",
  components: {
    Icon,
    Titre,
    Divider,
    LazyImage
  },
  props: {
    service: {
      type: Object,
      required: true
    },
    noel: {
      type: Boolean,
      required: false,
      default: false
    },
    magasinName: {
      type: String,
      required: false,
      default: ""
    }
  }
};
</script>

<template>
  <div>
    <div class="u-text-center">
      <div class="u-flex u-flex-justify-center">
        <Icon
          name="traiteur"
          size="lg"
          variant="primary"
          class="u-mt-xs"
        />
      </div>

      <Titre
        variant="primary"
        tag="h1"
        size="md"
        class="u-mt-sm"
      >
        {{ noel ? "Retirez vos produits en Click & Collect Traiteur de Fêtes" : "Retirez vos produits traiteur en Click & Collect" }}
      </Titre>
      <p class="u-flex u-flex-justify-center u-flex-align-center u-mt-md u-mb-lg">
        <Icon
          name="location"
          size="sm"
          class="u-mr-xxs"
        />
        Magasin {{ magasinName }}
      </p>
    </div>
    <Divider
      dotted
      class="u-my-md"
      size="sm"
    />
    <Titre
      v-if="service.details || service.image_plan_url || service.description"
      tag="p"
      size="sm"
      class="u-mb-sm u-mt-md u-mt-none@sm"
    >
      Localisation du point de retrait
    </Titre>
    <p>
      <template v-if="service.description">
        Le retrait de votre commande se fera au {{ service.description }}<br>
      </template>{{ service.details }}
    </p>
    <LazyImage
      :src="service.image_plan_url"
      class="u-mt-sm u-border-grey-3 height-auto"
      width="1000"
      dimension="2000"
      :show-fallback="false"
    />
  </div>
</template>

<style lang="scss" scoped>
.height-auto {
  height: auto;
}
</style>
